export const rouletteItemBgType = {
    NONE: 'NONE',
    IMAGE: 'IMAGE',
    COLOR: 'COLOR'
}

export const rouletteItemFrameType = {
    NONE: 'NONE',
    IMAGE: 'IMAGE',
    OUTLINE: 'OUTLINE'
}

export const roulettePinType = {
    NONE: 'NONE',
    IMAGE: 'IMAGE',
    VECTOR: 'VECTOR'
}

export const rouletteItemTextTransformation = {
    NONE: 'NONE',
    UPPERCASE: 'UPPERCASE',
    LOWERCASE: 'LOWERCASE'
}

export const rouletteItemTextAlignment = {
    LEFT: 'LEFT',
    CENTER: 'CENTER',
    RIGHT: 'RIGHT'
}

export const rouletteItemTextStyle = {
    BOLD: 'bold',
    ITALIC: 'italic',
    UNDERLINE: 'underline'
}
